"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const native_1 = require("@react-navigation/native");
const native_base_1 = require("native-base");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const Swipeable_1 = __importDefault(require("react-native-gesture-handler/Swipeable"));
const react_redux_1 = require("react-redux");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const AppBackground_1 = __importDefault(require("../../component/AppBackground"));
const Loader_1 = require("../../component/CharacterList/Loader");
const ConversationListItem_1 = __importDefault(require("../../component/Conversations/ConversationListItem"));
const theme_1 = require("../../helper/theme");
const conversation_1 = require("../../helper/conversation");
const useAppMessage_1 = require("../../hooks/useAppMessage");
const rootNavigation_1 = require("../../navigation/rootNavigation");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const AppIcons_1 = require("../../component/AppIcons");
const AppQuotaAlert_1 = __importDefault(require("../../component/AppQuotaAlert"));
const SearchInput_1 = __importDefault(require("../../component/AppInput/SearchInput"));
const BigButton_1 = __importDefault(require("../../component/GradientButton/BigButton"));
const useDevice_1 = require("../../hooks/useDevice");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const useConversations_1 = require("../../hooks/useConversations");
const character_1 = require("../../services/character");
const user_1 = require("../../store/selectors/user");
const user_2 = require("../../slices/user");
const Layout_1 = require("./Layout");
const AppText_1 = require("../../component/AppText");
const AllCharacterList = ({ route, navigation }) => {
    const { characterId, tutorMode } = route.params
        ?? { characterId: undefined, tutorMode: undefined };
    const { isTabOrDesktopDevice, isMobileScreen, isWebDevice, deviceHeight } = (0, useDevice_1.useDevice)();
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isFocused = (0, native_1.useIsFocused)();
    const { request } = (0, useRequest_1.default)();
    const { pickConversation } = (0, useConversations_1.useConversations)();
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const [conversations, setConversations] = (0, react_1.useState)();
    const [filteredConversations, setFilteredConversations] = (0, react_1.useState)();
    const [selectedCharacterId, setSelectedCharacterId] = (0, react_1.useState)('');
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [createButtonShown, setCreateButtonShown] = (0, react_1.useState)(true);
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const characterProfile = (0, react_redux_1.useSelector)(user_1.selectCharacterProfile);
    const conversation = (0, react_redux_1.useSelector)((state) => state.getUserOptions.conversation);
    const lastConversation = (0, react_redux_1.useSelector)(user_1.selectLastConversation);
    const lastMessage = (0, react_redux_1.useSelector)(user_1.selectLastMessage);
    const chatQuota = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan?.quota?.conversations);
    const characterQuota = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan.quota.characters);
    const { current: rows } = (0, react_1.useRef)([]);
    const prevOpenedRowRef = (0, react_1.useRef)();
    const loadAllConversations = (0, react_1.useCallback)(async (userId) => {
        setIsLoading(true);
        try {
            const conversations = await request(character_1.getAllConversations, userId);
            if (!conversations?.success || conversations?.code === "ERR_NETWORK") {
                showNotification("Network connection", conversations.message, "error");
            }
            else {
                const flattedConversations = (0, conversation_1.flatConversations)(conversations.data);
                const startedConversations = flattedConversations.filter((conversation) => (conversation?.lastMessage));
                setConversations(startedConversations);
            }
        }
        catch (error) {
            console.log(error);
        }
        setIsLoading(false);
    }, []);
    const openCharactersList = (0, react_1.useCallback)(async () => {
        if (chatQuota?.quota &&
            chatQuota.quota === chatQuota.consumed &&
            react_native_1.Platform.OS !== "web") {
            if (!fbUser?.uid) {
                dispatch((0, user_2.setUserAction)("signin"));
            }
            else {
                await dispatch((0, user_2.setUserAction)("membership"));
            }
        }
        else {
            navigation.navigate("Documents");
        }
    }, [dispatch, chatQuota, fbUser]);
    const onDeleteSuccess = (0, react_1.useCallback)(async () => {
        showNotification("Conversation Deleted", "Successfully removed..", "success");
    }, [showNotification]);
    const deleteConversationItem = (0, react_1.useCallback)(async (item) => {
        if (item) {
            await (0, character_1.deleteConversations)(item.id);
            dispatch((0, user_2.resetCharacter)());
            setConversations(conversations?.filter((conversation) => conversation?.id !== item.id));
            if (item.id === lastConversation?.id) {
                dispatch((0, user_2.resetLastConversation)());
            }
            ;
            if (item.id === lastMessage?.conversationId.toString()) {
                dispatch((0, user_2.resetLastMessage)());
            }
            ;
            if (item.participant?.id == route.params?.characterId) {
                navigation.navigate('Chats');
            }
            ;
            onDeleteSuccess();
        }
    }, [conversations, onDeleteSuccess, navigation]);
    (0, native_1.useFocusEffect)(react_1.default.useCallback(() => {
        //BackHandler not supported on web
        if (react_native_1.Platform.OS !== "web") {
            const onBackPress = () => {
                if (isFocused) {
                    react_native_1.BackHandler.exitApp();
                    return true;
                }
                else {
                    return false;
                }
            };
            react_native_1.BackHandler.addEventListener("hardwareBackPress", onBackPress);
            return () => react_native_1.BackHandler.removeEventListener("hardwareBackPress", onBackPress);
        }
    }, [isFocused]));
    (0, react_1.useEffect)(() => {
        // @todo: fix nested scroll warning
        react_native_1.LogBox.ignoreLogs([constants_1.IGNORE_NESTED_SCROLL_LOG]);
    }, []);
    (0, react_1.useEffect)(() => {
        if (isFocused && appUser?.id) {
            loadAllConversations(appUser.id);
        }
    }, [isFocused, appUser]);
    (0, react_1.useEffect)(() => {
        let wasUnmounted = false;
        if (isFocused
            && characterId
            && isWebDevice
            && characterProfile.id.toString() !== characterId) {
            const getCharacter = async () => {
                setSelectedCharacterId('');
                pickConversation(characterId);
            };
            getCharacter();
        }
        else {
            setSelectedCharacterId(characterProfile.id.toString());
        }
        ;
        return () => { wasUnmounted = true; };
    }, [characterProfile, isWebDevice, pickConversation, characterId, tutorMode, isFocused]);
    (0, react_1.useEffect)(() => {
        // sync WebSocket conversations
        if (conversations && lastConversation) {
            const currentLastConversation = conversations[0];
            if (currentLastConversation?.id !== lastConversation.id) {
                const isNewCharacter = conversations.every((conversation) => (conversation?.participant?.id.toString() !== lastConversation.participantId));
                if (isNewCharacter) {
                    setConversations([{
                            ...lastConversation,
                            participant: characterProfile,
                        }].concat(conversations));
                }
                else {
                    if (currentLastConversation?.participant?.id.toString() !== lastConversation.participantId) {
                        conversations.sort((nextConversation) => (nextConversation?.participant?.id.toString() === lastConversation.participantId ? -1 : 1));
                    }
                    const [oldConversation, ...restConversations] = conversations;
                    const wasConversationIdUpdated = (!oldConversation || oldConversation.id !== lastConversation.id);
                    setConversations([
                        (wasConversationIdUpdated
                            ? {
                                ...oldConversation,
                                ...lastConversation,
                            }
                            : oldConversation),
                    ].concat(restConversations));
                }
            }
        }
    }, [conversations, lastConversation]);
    (0, react_1.useEffect)(() => {
        // sync WebSocket last message
        if (conversations && lastMessage) {
            let sortedConversation = conversations;
            if (conversations?.[0]?.id != lastMessage.conversationId) {
                sortedConversation = Array.from(conversations).sort((nextConversation) => (nextConversation?.id == lastMessage.conversationId ? -1 : 1));
            }
            ;
            if (sortedConversation?.[0]?.id == lastMessage.conversationId
                && sortedConversation?.[0]?.lastMessage?.updatedAt !== lastMessage.updatedAt) {
                const [updatedConversation, ...restConversations] = sortedConversation;
                setConversations([({
                        ...updatedConversation,
                        lastMessage,
                    })].concat(restConversations));
            }
            ;
        }
    }, [lastMessage, lastConversation, conversations]);
    const handleSearch = (0, react_1.useCallback)((search) => {
        setFilteredConversations(search === '' ? null : conversations?.filter((conversation) => (conversation?.participant?.characterName.toLowerCase().includes(search.toLowerCase()))));
    }, [conversations]);
    const pressHandler = (0, react_1.useCallback)(async (item) => {
        await deleteConversationItem(item);
    }, [deleteConversationItem]);
    const renderRightAction = (0, react_1.useCallback)((color, x, progress, item) => {
        const trans = progress.interpolate({
            inputRange: [0, 1],
            outputRange: [x, 0],
        });
        return null; // Return null instead of commented code to avoid text node error
        // return (
        //   <Animated.View style={{ flex: 1, transform: [{ translateX: trans }] }}>
        //     <RectButton
        //       style={[
        //         {
        //           alignItems: "center",
        //           flex: 1,
        //           justifyContent: "center",
        //         },
        //         { backgroundColor: color },
        //       ]}
        //       onPress={() => {
        //         pressHandler(item);
        //       }}
        //     >
        //       <Pressable style={{ width: '100%', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        //         <DeleteIcon size={6} color={Colors.white} />
        //       </Pressable>
        //     </RectButton>
        //   </Animated.View>
        // );
    }, []);
    const rightSwipeActions = (0, react_1.useCallback)((progress, _dragAnimatedValue, item) => {
        // return (
        //   <View
        //     style={{
        //       width: 75,
        //       flexDirection: I18nManager.isRTL ? "row-reverse" : "row",
        //     }}
        //   />
        //     {/* {renderRightAction(Colors.red, 75, progress, item)} */}
        // );
    }, [renderRightAction]);
    const renderItem = (0, react_1.useCallback)(({ item, index }) => {
        const closeRow = () => {
            const prevOpenedRow = prevOpenedRowRef.current;
            if (prevOpenedRow && prevOpenedRow !== rows[index]) {
                prevOpenedRow.close();
            }
            prevOpenedRowRef.current = rows[index];
        };
        return ((0, jsx_runtime_1.jsxs)(Swipeable_1.default, { renderRightActions: (progress, dragX) => null, onSwipeableWillOpen: closeRow, ref: (ref) => rows[index] = ref, friction: 2, enableTrackpadTwoFingerGesture: true, rightThreshold: 80, children: [(0, jsx_runtime_1.jsx)(ConversationListItem_1.default, { item: item }), (0, jsx_runtime_1.jsx)(native_base_1.Divider, { bg: colors_1.Colors.DARK_600, thickness: "1", width: "90%", alignSelf: "center", position: "relative", bottom: 0 })] }, `${item?.id}-swipeitem`));
    }, [rightSwipeActions]);
    return ((0, jsx_runtime_1.jsx)(AppBackground_1.default, { children: isFocused && ((0, jsx_runtime_1.jsx)(Layout_1.TabLayout, { characterId: selectedCharacterId, children: (0, jsx_runtime_1.jsxs)(native_base_1.Stack, { flex: 1, justifyContent: "space-between", width: "100%", minWidth: 302.5, padding: 4, maxWidth: 768, alignSelf: "center", children: [(0, jsx_runtime_1.jsx)(native_base_1.Stack, { height: isWebDevice && isMobileScreen ? 3 : 2 }), (isLoading) && ((0, jsx_runtime_1.jsx)(native_base_1.VStack, { flex: 1, alignSelf: "flex-start", children: (0, jsx_runtime_1.jsx)(native_base_1.Stack, { height: theme_1.SCREEN_HEIGHT / 2, overflow: "hidden", alignContent: "center", alignSelf: "center", textAlign: "center", flexDirection: "row", children: (0, jsx_runtime_1.jsx)(Loader_1.ChatLoader, {}) }) })), (0, jsx_runtime_1.jsx)(native_base_1.Stack, { flex: 1, alignSelf: "flex-start", height: !(isWebDevice && isMobileScreen) ? deviceHeight : undefined, width: "100%", marginTop: !(isWebDevice && isMobileScreen) ? -1 : undefined, position: "relative", children: !isLoading && ((0, jsx_runtime_1.jsxs)(native_base_1.VStack, { space: 4, flex: 1, children: [!(isWebDevice && isMobileScreen) && ((0, jsx_runtime_1.jsx)(SearchInput_1.default, { placeholder: "Jump to chats", p: "3", fontSize: 16, onChangeText: (search) => handleSearch(search) })), (0, jsx_runtime_1.jsx)(AppQuotaAlert_1.default, {}), (0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureHandlerRootView, { style: {
                                        flex: 1,
                                    }, children: (0, jsx_runtime_1.jsx)(react_native_1.Animated.FlatList, { data: filteredConversations ?? conversations, ItemSeparatorComponent: () => ((0, jsx_runtime_1.jsx)(native_base_1.Spacer, { height: isWebDevice && isMobileScreen ? 0.5 : undefined, backgroundColor: isWebDevice && isMobileScreen
                                                ? undefined
                                                : colors_1.Colors.DARK_600 })), ListEmptyComponent: (0, jsx_runtime_1.jsxs)(native_base_1.VStack, { alignContent: "center", justifyContent: "center", textAlign: "center", alignItems: "center", alignSelf: "center", flex: 1, padding: 3, marginTop: (isWebDevice && isMobileScreen) ? '5px' : undefined, space: 3, width: "100%", children: [isWebDevice && isMobileScreen ? ((0, jsx_runtime_1.jsx)(AppIcons_1.NoChat, { width: 256, height: 256 })) : ((0, jsx_runtime_1.jsx)(AppIcons_1.NoChat, {})), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: {
                                                        fontSize: 24,
                                                        fontWeight: '500',
                                                        color: colors_1.Colors.white,
                                                        marginBottom: 10,
                                                        textAlign: 'center'
                                                    }, children: "Ready for Your Doc to Talk?" }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: {
                                                        fontSize: 16,
                                                        color: colors_1.Colors.DARK_200,
                                                        textAlign: 'center',
                                                        marginBottom: 30,
                                                    }, children: "Upload a document to create summaries, chat with them, and your conversations will appear here." })] }), scrollEventThrottle: 25, onScroll: ({ nativeEvent }) => {
                                            const scrolling = nativeEvent.contentOffset.y;
                                            if (scrolling > 100) {
                                                setCreateButtonShown(false);
                                            }
                                            else {
                                                setCreateButtonShown(true);
                                            }
                                        }, showsHorizontalScrollIndicator: !isMobileScreen ? false : undefined, style: {
                                            ...((react_native_1.Platform.OS === "ios" ||
                                                react_native_1.Platform.OS === "android") && {
                                                height: deviceHeight -
                                                    insets.top -
                                                    insets.bottom -
                                                    (constants_1.DISCOVER_MODE ? 150 : 100),
                                                paddingBottom: 100,
                                            }),
                                        }, renderItem: renderItem, keyExtractor: (item) => `${item?.id}-conversation-list` }) }), isWebDevice
                                    && isMobileScreen
                                    && !(filteredConversations ?? conversations)?.length
                                    && ((0, jsx_runtime_1.jsx)(BigButton_1.default, { onPress: () => { (0, rootNavigation_1.navigate)('Documents'); }, containerStyle: {
                                            marginTop: 'auto',
                                            marginBottom: 20,
                                        }, children: "Go to Documents" }))] })) })] }) })) }));
};
exports.default = AllCharacterList;
